import type React from 'react'
import type { ReactNode } from 'react'
import './styles.css'

interface Props extends React.ComponentPropsWithoutRef<'button'> {
    title: string
    size?: 'sm' | 'md' | 'lg'
    state?:
        | 'primary'
        | 'ghost'
        | 'dark'
        | 'default'
        | 'secondary'
        | 'info'
        | 'danger'
        | 'ghost_secondary'
    className?: string
    buttonType?: 'button' | 'submit'
    onClick?: () => void
    rounded?: boolean
    icon?: ReactNode
    iconRight?: ReactNode
}

const typeMapper = {
    primary: 'success',
    info: 'info',
    ghost: 'ghost',
    dark: 'dark',
    default: 'default',
    secondary: 'secondary',
    danger: 'danger',
    ghost_secondary: 'ghost_secondary',
}

const sizeMapper = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
}

const AppButton = ({
    title,
    size = 'md',
    state = 'primary',
    buttonType = 'button',
    disabled = false,
    className,
    rounded,
    icon,
    iconRight,
    ...rest
}: Props) => {
    const typeClass = typeMapper[state]
    const sizeClass = sizeMapper[size]
    return (
        <button
            type={buttonType}
            className={
                `flex items-center gap-2 display button ${
                    className === undefined || className === ''
                        ? ``
                        : `${className} `
                } ${typeClass} ${sizeClass} ${
                    rounded === true ? 'rounded-xl' : ''
                } ${disabled === true ? 'disabled ' : ''}` + (className ?? '')
            }
            disabled={disabled}
            {...rest}
        >
            {icon}
            <div className="truncate mx-auto">{title}</div>
            <div
                className={`ml-auto ${
                    iconRight !== undefined && iconRight !== null
                        ? ''
                        : 'hidden'
                }`}
                onClick={rest.onClick}
            >
                {iconRight}
            </div>
        </button>
    )
}

export default AppButton
